import axiosInstance from '../../../helpers/api';

export const getActiveAnnouncements = (body) => {
    return axiosInstance.get('/students/announcements', body);
};

